import { Avatar, Grid, Stack } from '@mui/material';
import { AppImages } from 'app/appImages';
import { MprcChip } from 'components';
import { AutoCompleteDataModel, AutoCompleteSuggestions } from 'components/MprcAutoComplete';
import { GroupUsages } from 'generated/CoreApi_v1';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GroupAutoComplete } from 'views/foundation/group/components/GroupAutoComplete';

////////////////////////////////////////////////////////////////////////////

interface IProps {
    channelId: string;
    onError: (e: any) => void;
    onItemsChange: (members: string[]) => void;
}

////////////////////////////////////////////////////////////////////////////

export const AddGroups: React.FC<IProps> = (props) => {

    const api = useCoreApi();
    const { channelId, onItemsChange, onError } = props;
    const { t } = useTranslation("knowledge");
    const [selectedGroups, setSelectedGroups] = useState<AutoCompleteDataModel[]>([]);

    ////////////////////////////////////////////////////////////////////////////
    ///
    const onChange = (item: AutoCompleteDataModel[]) => {
        if (item.length > 0) {
            if (selectedGroups.findIndex(x => x.key == item[0].key) === -1) {
                setSelectedGroups([...selectedGroups, item[0]]);
            }
        }
    };

    ////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        onItemsChange(selectedGroups.map(x => x.key));
    }, [selectedGroups]);

    return <Grid container spacing={2} direction="column" sx={{ minHeight: 150 }}>
        <Grid>
            <GroupAutoComplete
                autoFocus
                selectedItems={[]}
                multiSelect={true}
                onChange={onChange}
                onError={onError}
                groupUsages={GroupUsages.SubscribeChannelMembers}
                placeholder={t("Channel.Edit.Members.GroupsPlaceholder")}
                onGetDataCustom={({ searchText, pageNumber, pageSize }, signal) =>
                    new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve, reject) => {
                        api.v1.knowledgeSuggestions.channelMemberGroups({
                            channelId,
                            searchText: searchText ?? null,
                            pageNumber,
                            pageSize
                        }, { signal })
                            .then(result => resolve(result.data))
                            .catch(e => reject(e));
                    })
                }
            />
        </Grid>
        <Grid>
            <Stack direction="row" spacing={1}>
                {selectedGroups.map(item => {
                    return <MprcChip
                        size="small"
                        key={item.key}
                        label={item.label}
                        onDelete={() => {
                            const newSelectedUsers = selectedGroups.filter(x => x.key != item.key);
                            setSelectedGroups(newSelectedUsers);
                        }}
                        avatar={
                            <Avatar
                                src={
                                    item.thumbnailUrl == null
                                        ? AppImages.GroupThumbnail
                                        : item.thumbnailUrl
                                }
                            />
                        }
                    />;
                })}
            </Stack>
        </Grid>
    </Grid>;
};
